 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"api-credentials-api-credentials-module":"api-credentials-api-credentials-module","auth-auth-module":"auth-auth-module","claims-claims-module":"claims-claims-module","commissions-life-commissions-life-module":"commissions-life-commissions-life-module","common":"common","asana-asana-module":"asana-asana-module","data-hub-data-hub-module":"data-hub-data-hub-module","dmvic-dmciv-module":"dmvic-dmciv-module","heatmap-heatmap-module":"heatmap-heatmap-module","notification-notification-module":"notification-notification-module","payment-card-payments-card-module":"payment-card-payments-card-module","payment-mpesa-payments-mpesa-module":"payment-mpesa-payments-mpesa-module","payment-payment-module":"payment-payment-module","payments-ntsa-payments-ntsa-module":"payments-ntsa-payments-ntsa-module","promocode-promocode-module":"promocode-promocode-module","rbac-rbac-module":"rbac-rbac-module","credit-life-credit-life-module":"credit-life-credit-life-module","currency-currency-module":"currency-currency-module","default~bima-points-bima-points-module~client-client-module~dashboard-dashboard-module":"default~bima-points-bima-points-module~client-client-module~dashboard-dashboard-module","default~bima-points-bima-points-module~client-client-module":"default~bima-points-bima-points-module~client-client-module","bima-points-bima-points-module":"bima-points-bima-points-module","domestic-claim-domestic-claim-module":"domestic-claim-domestic-claim-module","domestic-policy-domestic-policy-module":"domestic-policy-domestic-policy-module","evacuation-claim-evacuation-claim-module":"evacuation-claim-evacuation-claim-module","evacuation-policy-evacuation-policy-module":"evacuation-policy-evacuation-policy-module","financial-financial-module":"financial-financial-module","firebase-auth":"firebase-auth","gadget-claim-gadget-claim-module":"gadget-claim-gadget-claim-module","gadget-policy-gadget-policy-module":"gadget-policy-gadget-policy-module","golf-claim-golf-claim-module":"golf-claim-golf-claim-module","golf-policy-golf-policy-module":"golf-policy-golf-policy-module","invoice-payments-invoice-payments-module":"invoice-payments-invoice-payments-module","lastexpense-policy-lastexpense-policy-module":"lastexpense-policy-lastexpense-policy-module","leads-leads-module":"leads-leads-module","life-policy-life-policy-module":"life-policy-life-policy-module","manual-sale-motor-manual-sale-motor-module":"manual-sale-motor-manual-sale-motor-module","medical-claim-medical-claim-module":"medical-claim-medical-claim-module","medical-policy-medical-policy-module":"medical-policy-medical-policy-module","motor-claim-motor-claim-module":"motor-claim-motor-claim-module","motor-policy-motor-policy-module":"motor-policy-motor-policy-module","motor-policy-number-motor-policy-number-module":"motor-policy-number-motor-policy-number-module","motor-valuation-motor-valuation-module":"motor-valuation-motor-valuation-module","other-manual-sales-other-manual-sales-module":"other-manual-sales-other-manual-sales-module","pata-pesa-pata-pesa-module":"pata-pesa-pata-pesa-module","payment-plan-calculator-payment-plan-calculator-module":"payment-plan-calculator-payment-plan-calculator-module","payment-plan-payment-plan-module":"payment-plan-payment-plan-module","personal-accident-claim-personal-accident-claim-module":"personal-accident-claim-personal-accident-claim-module","personal-accident-policy-personal-accident-policy-module":"personal-accident-policy-personal-accident-policy-module","policies-policies-module":"policies-policies-module","referral-thirdparty-referral-thirdparty-module":"referral-thirdparty-referral-thirdparty-module","referrals-referrals-module":"referrals-referrals-module","telemedicine-policy-telemedicine-module":"telemedicine-policy-telemedicine-module","travel-claim-travel-claim-module":"travel-claim-travel-claim-module","travel-policy-travel-policy-module":"travel-policy-travel-policy-module","underwriter-contact-underwriter-contact-module":"underwriter-contact-underwriter-contact-module","unisure-unisure-module":"unisure-unisure-module","valuation-valuation-module":"valuation-valuation-module","wallet-transactions-wallet-transactions-module":"wallet-transactions-wallet-transactions-module","county-reps-county-reps-module":"county-reps-county-reps-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
